import { BehaviorSubject, Observable } from 'rxjs'
import { Epic } from 'redux-observable'
import { ReduxAction } from '../reducers/reducerType'

export let epic$: BehaviorSubject<Epic> | null = null

export function addStream (stream$: Observable<ReduxAction>);
export function addStream (stream$: Epic);
export function addStream (stream$: Observable<ReduxAction> | Epic) {

  if (epic$ === null) {

    if (!(stream$ instanceof Observable)) {

      epic$ = new BehaviorSubject(stream$)

    }

  }
  else {

    if (stream$ instanceof Observable) {

      epic$.next(() => stream$)

    }
    else {

      epic$.next(stream$)

    }

  }

}

